import * as React from "react";
const IconUserProfile = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5453 19.5413C18.5519 16.8842 15.9901 14.9924 12.9865 14.9924C9.98283 14.9924 7.42105 16.8842 6.42762 19.5413M19.5453 19.5413C21.6536 17.7079 22.9865 15.0058 22.9865 11.9924C22.9865 6.46958 18.5093 1.99243 12.9865 1.99243C7.4636 1.99243 2.98645 6.46958 2.98645 11.9924C2.98645 15.0058 4.3193 17.7079 6.42762 19.5413M19.5453 19.5413C17.7895 21.0681 15.4959 21.9924 12.9865 21.9924C10.477 21.9924 8.18339 21.0681 6.42762 19.5413M15.9865 8.99243C15.9865 10.6493 14.6433 11.9924 12.9865 11.9924C11.3296 11.9924 9.98645 10.6493 9.98645 8.99243C9.98645 7.33558 11.3296 5.99243 12.9865 5.99243C14.6433 5.99243 15.9865 7.33558 15.9865 8.99243Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default IconUserProfile;
